<template>
  <div
    class="switch-languages"
    v-if="showLanguageSwitch"
  >
    <div
      v-for="lang in regionLanguages"
      :key="lang.id"
      class="lang-label"
      @click="changeLang(lang)"
    >
      {{ $t(lang.name) }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import logInStatusMixin from '@/modules/logInStatusMixin'

export default {
  mixins: [logInStatusMixin],
  computed: {
    ...mapGetters('language', ['regionLanguages']),
    showLanguageSwitch () {
      return this.regionLanguages.length > 1 && this.showLoggedInContent
    },
  },
  methods: {
    ...mapActions('language', ['switchLang']),
    changeLang (val) {
      this.switchLang(val.name)
    },
  },
}
</script>

<style scoped lang="scss">
@import "~styles/settings";
.switch-languages {
  margin-right: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    cursor: pointer;
    color: #fff;
    width: 2rem;
    text-align: center;
    + div {
      border-left: 1px solid #fff;
    }
  }
}
</style>
